// Auto-height for iframe embedding. The widget posts its rendered height to the
// parent; the embed snippet (public/embed.js) resizes the iframe. Height is not
// sensitive, so it is posted to '*'; the snippet verifies the message origin.
const HEIGHT_MESSAGE = 'finavest:height';

export function setupEmbed(): void {
  const params = new URLSearchParams(location.search);
  const embedded = params.get('embed') === '1' || window.self !== window.top;
  if (embedded) document.documentElement.classList.add('is-embedded');
  // Host-chosen theme (embed.js maps the host's data-theme onto this param).
  // 'dark' = the finavest.ch palette (styles.css `html[data-theme='dark']`);
  // anything else keeps the light default, so existing embeds never change.
  if (params.get('theme') === 'dark') document.documentElement.dataset.theme = 'dark';

  if (window.parent === window) return; // not in an iframe → nothing to post

  let last = 0;
  const post = (): void => {
    const h = Math.ceil(document.documentElement.getBoundingClientRect().height);
    if (h !== last) {
      last = h;
      window.parent.postMessage({ type: HEIGHT_MESSAGE, height: h }, '*');
    }
  };

  new ResizeObserver(post).observe(document.documentElement);
  window.addEventListener('load', post);
  window.addEventListener('resize', post);
  post();
}
